import React, { createContext, useContext, useState } from 'react'
import { ReceptorScanType } from '../../Evidence/evidence.constants'

type AutomatedScanContextType = {
  selectedScan: ReceptorScanType
  setSelectedScan: (scanType: ReceptorScanType) => void
  initialReceptorModelId?: string
  setInitialReceptorModelId: (modelId: string | undefined) => void
  initialFolderScanReceptorId?: string
  setInitialFolderScanReceptorId: (receptorId: string | undefined) => void
}

const AutomatedScanContext = createContext<AutomatedScanContextType>({
  selectedScan: ReceptorScanType.EVIDENCE_RECEPTOR,
  setSelectedScan: () => undefined,
  setInitialReceptorModelId: () => undefined,
  setInitialFolderScanReceptorId: () => undefined,
})

export const useAutomatedScanContext = (): AutomatedScanContextType =>
  useContext(AutomatedScanContext)

export const AutomatedScanContextProvider = ({
  children,
}: {
  children: React.ReactNode
}): JSX.Element => {
  const [selectedScan, setSelectedScan] = useState<ReceptorScanType>(
    ReceptorScanType.EVIDENCE_RECEPTOR,
  )
  const [initialReceptorModelId, setInitialReceptorModelId] = useState<
    string | undefined
  >(undefined)
  const [initialFolderScanReceptorId, setInitialFolderScanReceptorId] =
    useState<string | undefined>(undefined)

  return (
    <AutomatedScanContext.Provider
      value={{
        selectedScan,
        setSelectedScan,
        initialReceptorModelId,
        setInitialReceptorModelId,
        initialFolderScanReceptorId,
        setInitialFolderScanReceptorId,
      }}
    >
      {children}
    </AutomatedScanContext.Provider>
  )
}
